import * as React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { getCallUsage } from 'features/Numbers/Numbers.actions'
import { CallsTrendsVolume } from './CallsTrendsVolume'
import { getDateInterval, getCallsForPeriod } from '../../utils'
import * as sMarg from 'styles/modules/margins.scss'

const stateToProps = ({ numbers }, { numberId }) => {
  const limit = 11000
  const page = 1
  const cacheKey = `${numberId}-${page}-${limit}`
  const callUsage = get(numbers, ['callUsage', cacheKey], {})
  return {
    numberId,
    callUsage,
    limit,
    page,
    cacheKey,
  }
}

const dispatchToProps = {
  getCallUsage,
}

export interface ICallsTrendsVolumeContainerProps {
  numberId: string
}

class CallsTrendsVolumeContainerComponent extends React.Component<any> {
  componentDidMount() {
    const { getCallUsage, numberId, page, limit, cacheKey } = this.props
    if (numberId) {
      getCallUsage({ numberIds: [numberId], page, limit, cacheKey })
    }
  }
  render() {
    const { callUsage, numberId, inactiveMessage } = this.props
    const periodValue = 28
    const periodUnit = 'day'
    const sumPeriod = 'day'
    const dateInterval = getDateInterval({ periodValue, periodUnit, sumPeriod })
    const { calls, callsPrevious } = getCallsForPeriod({
      callsRaw: callUsage.data,
      periodValue,
      periodUnit,
    })

    const extraProps = inactiveMessage
      ? {
          overlayText: inactiveMessage,
        }
      : {
          to: `/dashboard/analytics?serviceIds=${numberId}`,
          toText: 'Call analytics',
        }

    return (
      <CallsTrendsVolume
        calls={calls}
        callsPrevious={callsPrevious}
        loading={callUsage.loading}
        dateInterval={dateInterval}
        sumPeriod={sumPeriod}
        periodValue={periodValue}
        periodUnit={periodUnit}
        dateFormat="D MMM"
        height={200}
        className={sMarg.mb30}
        {...extraProps}
      />
    )
  }
}

export const CallsTrendsVolumeContainer = connect(
  stateToProps,
  dispatchToProps
)(CallsTrendsVolumeContainerComponent) as React.SFC<ICallsTrendsVolumeContainerProps>



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsTrendsVolume/CallsTrendsVolume.container.tsx